import "./LoadingHome.css";
import { motion, AnimatePresence } from 'framer-motion';

var doorLeftName = "door-left";
var doorRightName = "door-right";

export default function LoadingHome(props: { imagesLoaded: boolean }) {
    return (
        <AnimatePresence>
            (!imagesLoaded
            && <motion.div className={doorLeftName}
                initial={{ x: 0 }}
                animate={{ x: '-100%' }}
                transition={{ delay: 1.0, duration: 1.0 }} />
            && <motion.div className={doorRightName}
                initial={{ x: 0 }}
                animate={{ x: '100%' }}
                transition={{ delay: 1.0, duration: 1.0 }} />
            )
        </AnimatePresence>
    );
}